export function createResourceLoaderMixin(alcaeus) {
  function ResourceLoaderMixin(base) {
    return class extends base {
      load(headers) {
        return alcaeus().loadResource(this.id.value, headers);
      }

    };
  }

  ResourceLoaderMixin.shouldApply = resource => {
    return resource.id.termType === 'NamedNode';
  };

  return ResourceLoaderMixin;
}